import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ProfileEditor from "../../components/SettingsComponents/ProfileEditor";
import ProfilePage from "../../components/SettingsComponents/ProfilePage";
import AccountSecurity from "../../components/SettingsComponents/AccountSecurity";
import Announcement from "../../components/SettingsComponents/Announcements";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubscribedCourse } from "../../store2/features/subscribedCourseSlice";

const SideBarItem = ({ isActive, text, onClick }) => {
  const activeStyle = isActive ? "sub-menu-item active" : "sub-menu-item";
  const textStyle = {
    textDecoration: isActive ? "underline" : "none",
    fontWeight: isActive ? "bold" : "",
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <li className={activeStyle} onClick={handleClick}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
        }}
      >
        <span style={textStyle}>{text}</span>
      </div>
    </li>
  );
};

const SideBar = ({ setCurrentPage, currentPage }) => {
  const [userDetails, setUserDetails] = useState(false);
  const course = useSelector((state) => state.subscribedCourses.items);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSubscribedCourse());
  }, [dispatch]);
  useEffect(() => {
    course && course.length <= 0 && setCurrentPage("Edit Profile");
  }, [course]);



  useEffect(() => {
    if (window.location.toString().includes("user")) {
      let userDetailss = localStorage.getItem("userDetails");
      if (userDetailss) {
        setUserDetails(JSON.parse(userDetailss));
      }
    }
  }, []);

  
  const initials = userDetails?.firstName
    ? `${userDetails.firstName.charAt(0).toUpperCase()}${userDetails.lastName? userDetails.lastName.charAt(0).toUpperCase(): ''}`
    : "User";

  const menuItems = [
    {
      text: "Profile",
      isActive: currentPage === "Profile",
      onClick: () => {
        setCurrentPage("Profile");
      },
      new: true,
    },
    {
      text: "Edit Profile",
      isActive: currentPage === "Edit Profile",
      onClick: () => {
        setCurrentPage("Edit Profile");
      },
      new: true,
    },
    {
      text: "Account Security",
      isActive: currentPage === "Account Security",
      onClick: () => {
        setCurrentPage("Account Security");
      },
      new: true,
    },
    {
      text: "Subscriptions",
      isActive: currentPage === "",
      onClick: () => {
        setCurrentPage("ProfilePage");
      },
      new: false,
    },
    {
      text: "Payment Methods",
      isActive: currentPage === "",
      onClick: () => {
        setCurrentPage("ProfilePage");
      },
      new: false,
    },
    {
      text: "Privacy",
      isActive: currentPage === "",
      onClick: () => {
        setCurrentPage("ProfilePage");
      },
      new: false,
    },
    {
      text: "Notifications",
      isActive: currentPage === "Notifications",
      onClick: () => {
        setCurrentPage("Notifications");
      },
      new: false,
    },
  ];

  return (
    <div className="d-flex flex-column p-3 bg-light mx-3">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <div
          style={{
            border: "2px solid blue",
            borderRadius: "50%",
            height: "100px",
            width: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "18px",
            fontWeight: "bold",
            color: "blue",
          }}
        >
          <span>{initials}</span>
        </div>
        <span>{userDetails.username}</span>
      </div>
      <hr />
      <ul
        className="sub-men list-unstyled" // sub menu class is changed somewhere
      >
        {course && course.length > 0
          ? menuItems.map((item) => <SideBarItem key={item.text} {...item} />)
          : menuItems
              .filter((item) => item.new)
              .map((item) => <SideBarItem key={item.text} {...item} />)}
      </ul>
      ;
    </div>
  );
};

const Profile = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const [currentPage, setCurrentPage] = useState("Profile");

  useEffect(() => {
    //screen size
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.title = "Profile";
  }, []);

  return (
    // <div>
    // 	<ProfilePage user={userDetails} />
    // </div>
    <div
      className={`container d-flex ${
        isSmallScreen ? "flex-column" : "flex-row"
      } border my-4`}
    >
      <div className="col-md-3 bg-light">
        <SideBar setCurrentPage={setCurrentPage} currentPage={currentPage} />
      </div>
      <div className="container d-flex flex-column">
        <h2 className="text-center mb-2 mt-3 fw-bold"> {currentPage} </h2>
        <hr />
        {/* <ProfileEditor /> */}
        {currentPage === "Profile" && <ProfilePage />}
        {currentPage === "Edit Profile" && <ProfileEditor />}
        {currentPage === "Account Security" && <AccountSecurity />}
        {currentPage === "Notifications" && <Announcement />}
        {/* <ProfilePage /> */}
      </div>
    </div>
  );
};
export default Profile;
